export default [
    {
        path: '/topic',
        name: 'Topics',
        component: () => import('@/views/topic/Topic.vue'),
        meta: {
            layout: 'Default',
            abilities: [['manage', 'topics']]
        }
    },
    {
        path: '/topic/:slug',
        name: 'Topic Detail',
        component: () => import('@/views/topic/TopicDetail.vue'),
        meta: {
            layout: 'Default',
            abilities: [['manage', 'topics']]
        }
    },
]